import { IInfrastructureType } from '../../types/infrastructure';
import { IApplicationState } from '../../types/redux';

export function selectTypes(state: IApplicationState): IInfrastructureType[] {
  return Object.values(state.infrastructure.types);
}
